export const buttonsContainerCss = {
  display: "flex" as const,
  flexDirection: "row" as const,
  justifyContent: "start" as const,
  gap: "16px",
};

export const copyButtonCss = {
  height: "27px",
};
